import { getPatternStyles, patternFns } from './runtime.js';
import { memo } from '../helpers.js';
import { css } from '../css/index.js';

const boxConfig = { transform(props) {
  return props;
} }

export function boxRaw(styles) {
  const s = getPatternStyles(boxConfig, styles || {})
  return boxConfig.transform(s, patternFns)
}

export const box = /* @__PURE__ */ Object.assign(/* @__PURE__ */ memo(function box(styles = {}) {
  return css(boxRaw(styles))
}), { raw: boxRaw, propKeys: [] })